import { library } from '@fortawesome/fontawesome-svg-core';
import { faArrowPointer, faBan, faCircle, faCircleHalfStroke, faFont, faLink, faPalette, faTextHeight, faToggleOff, faXmark } from '@fortawesome/free-solid-svg-icons';
import { faCircle as farCircle } from '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

export { default as App } from './App.vue';

library.add( faCircle, farCircle, faXmark, faBan, faArrowPointer, faCircleHalfStroke, faTextHeight, faPalette, faLink, faFont, faToggleOff);

export function onCreateApp(app) {
    app.component('fa-icon', FontAwesomeIcon);
}
